export default "__VITE_ASSET__e8cebd9d__"